import { useRef, useEffect } from "react";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export const ScrollTriggerSimple = (whichDistanceY, whichDistanceX, startPos, bottomPos) => {
  const nodeRef = useRef();
  useEffect(() => {
    gsap.from(nodeRef.current, {
      scrollTrigger: {
        trigger: nodeRef.current,
        toggleActions: "play none none none",
        start: startPos,
        end: bottomPos,
      },
      y: whichDistanceY,
      x: whichDistanceX,
      duration: 1,
      autoAlpha: 0,
    });
  });
  return { ref: nodeRef };
};

export default ScrollTriggerSimple;
